import React from 'react';
import styled from 'styled-components/macro';
import { useDragLayer, DragLayerMonitor, XYCoord } from 'react-dnd';
import { Item, Displayname } from '../DSPItem/DSPItem';
import { boxShadow } from 'styles/base-classes';

const PreviewItem = styled(Item)`
  background: rgba(255, 255, 255, 0.75);
  border: 1px solid ${({ theme }): string => theme.LightGrey};
  position: fixed;
  left: 0;
  top: 0;
  pointer-events: none;
  padding-left: 1em;
  padding-right: 1em;
  box-shadow: ${boxShadow};
  z-index: 100;
`;

function collect(monitor: DragLayerMonitor): IDraglayerProps {
  const dragItem = monitor.getItem();
  const item = dragItem?.item;

  return {
    id: item?.id,
    displayName: item?.displayName,
    color: item?.color,
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
  };
}

function getItemStyles(currentOffset: XYCoord | null): any {
  if (!currentOffset) {
    return {
      display: 'none',
    };
  }

  const x = currentOffset.x;
  const y = currentOffset.y;
  const transform = `translate(${x}px, ${y}px)`;

  return {
    pointerEvents: 'none',
    transform: transform,
    WebkitTransform: transform,
    opacity: 0.5,
  };
}

interface IDraglayerProps {
  id: string;
  color: string;
  displayName: string;
  currentOffset: XYCoord | null;
  isDragging: boolean;
}

const ItemPreview: React.FC = () => {
  const { displayName, color, isDragging, currentOffset } = useDragLayer(
    collect
  );

  if (!isDragging) {
    return null;
  }

  return (
    <PreviewItem className="item preview" style={getItemStyles(currentOffset)}>
      <Displayname color={color}>{displayName}</Displayname>
    </PreviewItem>
  );
};

export default ItemPreview;
